var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPetalasDeovita(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0333109 15.1305C-0.523343 8.51793 5.97389 3.28181 13.7309 4.11113C13.9196 4.13116 13.9657 4.4371 13.7789 4.47179C7.44291 5.65032 5.47668 15.4163 0.87224 15.7123C0.46315 15.7387 0.0688859 15.5531 0.0333109 15.1305Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0333109 15.1305C0.0491464 15.3184 0.138281 15.4569 0.265623 15.5531C1.17105 16.0941 2.70573 14.5279 3.72113 11.2587C5.21045 6.46307 9.7684 4.21438 13.7309 4.11113C5.97389 3.28181 -0.523343 8.51793 0.0333109 15.1305Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6176 28.7655C8.22923 29.3418 3.17065 22.6164 3.97185 14.5872C3.99128 14.3919 4.28668 14.3443 4.32019 14.5375C5.45876 21.0959 14.8937 23.1311 15.1797 27.8971C15.2051 28.3206 15.0259 28.7287 14.6176 28.7655Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6176 28.7655C14.799 28.7491 14.9328 28.6566 15.0259 28.5248C15.5485 27.5876 14.0354 25.9991 10.8771 24.9482C6.24404 23.4064 4.0716 18.6888 3.97185 14.5872C3.17065 22.6164 8.22923 29.3418 14.6176 28.7655Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.79 13.6691C28.3468 20.2817 21.8494 25.5178 14.0924 24.6885C13.9038 24.6684 13.8578 24.3625 14.0444 24.3279C20.3805 23.1493 22.3467 13.3833 26.9511 13.0872C27.3602 13.0609 27.7544 13.2464 27.79 13.6691Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.79 13.6691C27.7742 13.4811 27.6851 13.3429 27.5576 13.2465C26.6521 12.7056 25.1174 14.2717 24.1021 17.5409C22.6127 22.3366 18.0549 24.5853 14.0924 24.6885C21.8494 25.5178 28.3468 20.2817 27.79 13.6691Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2058 0.03448C19.5942 -0.541711 24.6528 6.18356 23.8516 14.2128C23.8322 14.4081 23.5366 14.4558 23.5032 14.2626C22.3645 7.70413 12.9297 5.66885 12.6437 0.902943C12.6183 0.479405 12.7975 0.0713036 13.2058 0.03448Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2058 0.03448C13.0243 0.0508713 12.8905 0.143044 12.7974 0.274945C12.2748 1.21215 13.7879 2.80069 16.9463 3.85173C21.5793 5.39333 23.7518 10.1113 23.8516 14.2128C24.6528 6.18356 19.5942 -0.541711 13.2058 0.03448Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPetalasDeovita);
export default __webpack_public_path__ + "static/media/petalas-deovita.89c70d3b2c7c623593de0ac42a91f154.svg";
export { ForwardRef as ReactComponent };